import { render, staticRenderFns } from "./InputEmail.vue?vue&type=template&id=807ffe02&scoped=true&"
import script from "./InputEmail.vue?vue&type=script&lang=js&"
export * from "./InputEmail.vue?vue&type=script&lang=js&"
import style0 from "./InputEmail.vue?vue&type=style&index=0&id=807ffe02&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807ffe02",
  null
  
)

export default component.exports